import { createSelector } from "reselect";

const baseSelector = (state) => state.manufacturer;

export const getIsManufacturerFetching = createSelector(baseSelector, (state) => state.isFetching);

export const getManufacturersFull = createSelector(baseSelector, (state) => state.data || []);

/**
 * Compatibility function for legacy code
 * @param {object} state
 */
export const getManufacturers = createSelector(getManufacturersFull, (manufacturers) =>
  manufacturers.map((m) => ({
    ...m,
    tools: m.tools.map((o) => o.id),
    upgrades: m.upgrades.map((o) => o.id),
    systemTypes: m.systemTypes.map((o) => o.id),
    sparePartTypes: m.sparePartTypes.map((o) => o.id),
  }))
);

export const getImages = createSelector(getManufacturersFull, (manufacturers) =>
  manufacturers
    .reduce((acc, m) => acc.concat(m.tools, m.upgrades, m.sparePartTypes, m.systemTypes), [])
    .reduce(
      (acc, { id, images }) => ({
        ...acc,
        [id]: images,
      }),
      {}
    )
);
